import React, {lazy, Suspense, useState, useEffect} from 'react';

const Gallery = (props) => {
  let ComponentLazy = null;
  const [width, setWidth] = useState(window.innerWidth)
  const [row, setRow] = useState('')

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  },[]);

  useEffect(() => {
    if(width > 768)
    {
      setRow('')
    }else{
      if(props.attributes.page === "moment_detail" || props.attributes.page === "city_detail")
      {
        setRow(' row')
      }
    }
  },[width])

  const handleResize = () =>{
    setWidth(window.innerWidth)
  }

  if(props.attributes.page === "moment_detail") { ComponentLazy = lazy(() => import("./Content/MomentDetail"));} 
  else if(props.attributes.page === "city_detail") { ComponentLazy = lazy(() => import("./Content/CityDetail"));}
  else if(props.attributes.page === "city_portfolio") { ComponentLazy = lazy(() => import("./Content/CityPortfolio"));}
  else if(props.attributes.page === "moment_portfolio") { ComponentLazy = lazy(() => import("./Content/MomentPortfolio"));}

  return (
    <div className='col-xs-12' style={{padding: 0}}>
      <div className={"Gallery"+row} id='Gallery'>
        <Suspense fallback={<div>Loading...</div>}>
          <ComponentLazy attributes={props}/>
        </Suspense>
      </div>
    </div>
  )
}
export default Gallery;